import { createContext } from "react";
import { ClientObject, EtudeObject, ProjetObject } from "../../types/models";
export const ProjetContext = createContext({
  client: ClientObject,
  projet: ProjetObject,
  etudes: Array<typeof EtudeObject>(),
});
